module.exports = __webpack_public_path__ + "static/media/target-small_2x.6e402e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/target-small_2x.png
// module id = 850
// module chunks = 27